export function isPromise<T = any>(arg: any): arg is Promise<T> {
  return typeof arg?.then === "function";
}
